<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script setup>
import { login } from "@/api/index";
import { setToken } from "@/utils/auth";

async function getLogin() {
  let value = {
    username: "普通用户",
    password: "Lsstjt.2024",
  };

  let result = await login(value);
  console.log("当前token", result);
  if (result.data.code != 200) return;
  setToken(result.data.token);
}

getLogin();
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  /* margin-top: 60px; */
}
.el-tabs__item {
  color: #000000 !important;
}
.el-tabs__active-bar {
  background-color: #95c41f;
}
.el-tabs__content {
  height: 290px;
}
.el-carousel__container {
  height: 200px;
}
@media (max-width: 1000px) {
  .el-carousel__container {
    height: 230px;
  }
  html,
  body {
    max-width: 100%;
    overflow-x: hidden;
  }
  .el-carousel__button {
    width: 27px;
  }
  /* .el-carousel__indicator{width:25px;} */
}
</style>
